const DEFAULT_OPTIONS = {
    closeOnOutsideClick: true,
    closeOnEscape: true,
    closeOthers: true,
    openClass: null,
    hiddenClass: 'hidden',
};

const controllers = new Set();

export class DropdownController {
    constructor(button, menu, options = {}) {
        this.button = resolveElement(button);
        this.menu = resolveElement(menu);
        this.options = { ...DEFAULT_OPTIONS, ...options };
        this.isOpen = false;

        if (!this.button || !this.menu) {
            return;
        }

        this.handleButtonClick = this.handleButtonClick.bind(this);
        this.handleDocumentClick = this.handleDocumentClick.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);

        this.button.addEventListener('click', this.handleButtonClick);
        document.addEventListener('click', this.handleDocumentClick);
        document.addEventListener('keydown', this.handleKeydown);

        controllers.add(this);
    }

    handleButtonClick(event) {
        event.preventDefault();
        event.stopPropagation();
        this.toggle();
    }

    handleDocumentClick(event) {
        if (!this.options.closeOnOutsideClick || !this.isOpen) {
            return;
        }

        if (event.target === this.button || this.button.contains(event.target)) {
            return;
        }

        if (event.target === this.menu || this.menu.contains(event.target)) {
            return;
        }

        this.close();
    }

    handleKeydown(event) {
        if (!this.options.closeOnEscape || !this.isOpen) {
            return;
        }

        if (event.key === 'Escape') {
            this.close();
        }
    }

    toggle() {
        if (this.isOpen) {
            this.close();
        } else {
            this.open();
        }
    }

    open() {
        if (this.isOpen) {
            return;
        }

        if (this.options.closeOthers) {
            controllers.forEach((controller) => {
                if (controller !== this) {
                    controller.close();
                }
            });
        }

        this.menu.classList.remove(this.options.hiddenClass);
        if (this.options.openClass) {
            this.menu.classList.add(this.options.openClass);
        }
        this.isOpen = true;
    }

    close() {
        if (!this.isOpen) {
            return;
        }

        if (this.options.openClass) {
            this.menu.classList.remove(this.options.openClass);
        }
        this.menu.classList.add(this.options.hiddenClass);
        this.isOpen = false;
    }

    destroy() {
        this.close();
        this.button?.removeEventListener('click', this.handleButtonClick);
        document.removeEventListener('click', this.handleDocumentClick);
        document.removeEventListener('keydown', this.handleKeydown);
        controllers.delete(this);
    }
}

function resolveElement(target) {
    if (!target) {
        return null;
    }

    if (typeof target === 'string') {
        return document.querySelector(target);
    }

    if (target instanceof HTMLElement) {
        return target;
    }

    return null;
}
